import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";
import FoodDialog from "dialogs/FoodDialog";
import { Colors } from "helpers/Consts";
import { useState } from "react";
import { IProduct } from "types/Product";
import { UseQueryResult } from "react-query";
import { IShoppingBagData } from "../../types/ShoppingBag";
import { IPlaceData } from "../../types/Place";
import PriceTag from "dialogs/FoodDialog/components/priceTag";

type Props = {
  product: IProduct;
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
  placeInfo: IPlaceData | undefined
};

function FoodCard({ product,shoppingBagQuery,placeInfo }: Props) {
  //console.log(product)
  const [open, setOpen] = useState<boolean>(false);

  const handleDialog = () => {
    return setOpen(!open);
  };

  return (
    <>
      <FoodDialog open={open} handleClose={handleDialog} product={product} shoppingBagQuery={shoppingBagQuery} placeInfo={placeInfo}/>
      <Card sx={{ maxWidth: 600 }} onClick={handleDialog}>
        <CardActionArea>
          <CardContent>
            <Box sx={{ display: "flex" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontWeight: 200 }}
                    sx={{
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                        md: "18px",
                      },
                    }}
                  >
                    {product.name}
                  </Typography>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    style={{ fontWeight: 200 }}
                    sx={{
                      color: Colors.grayTextColorDarkestDark,
                      alignSelf: "start",
                      justifySelf: "start",
                      fontSize: {
                        xs: "12px",
                        sm: "14px",
                        md: "16px",
                      },
                    }}
                  >
                    {product.description}
                  </Typography>
                </Box>

                <Box>
                  {product?.show_people_served_information ? (<Typography
                  variant="body2"
                  color="black"
                  style={{
                    fontWeight: 700,
                    fontSize: "13px",
                  }}
                >
                  Serve até {product.people_served} pessoa(s)
                </Typography>) : null}

                  <Box
                    sx={{
                      display: "flex",
                    }}
                  >
                    <PriceTag product={product} />
                  </Box>
                </Box>
              </Box>
              <Box sx={{ flexGrow: 1 }} />
              {product.image ? (
                <Box
                  component="img"
                  sx={{
                    borderRadius: "7px",
                    width: "150px",
                    height: "150px",
                  }}
                  src={product.image !== null ? product.image : ""}
                  alt={product.name}
                />
              ) : (
                <Box
                component="img"
                  sx={{
                    borderRadius: "7px",
                    width: "150px",
                    height: "150px",
                  }}
                  src={require("assets/img/noImageProduct.png")}
                  alt={product.name}
                />
              )}
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  );
}

export default FoodCard;
